export default __webpack_public_path__ + "static/media/features-home-element-01.1d9f3ca1.png";